const REDIRECT_QUERY_PARAM = 'redirect';
const POST_AUTH_REDIRECT_KEY = 'postAuthRedirect';

const isSafeInternalRedirect = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//');

export const buildLoginPathWithRedirect = (path: string): string => {
  if (!isSafeInternalRedirect(path)) {
    return '/login';
  }

  const params = new URLSearchParams({ [REDIRECT_QUERY_PARAM]: path });
  return `/login?${params.toString()}`;
};

export const getSafeRedirectFromSearch = (search: string): null | string => {
  const value = new URLSearchParams(search).get(REDIRECT_QUERY_PARAM);
  if (!value || !isSafeInternalRedirect(value)) {
    return null;
  }

  return value;
};

export const persistPostAuthRedirect = (path: string): void => {
  if (!isSafeInternalRedirect(path)) {
    return;
  }

  localStorage.setItem(POST_AUTH_REDIRECT_KEY, JSON.stringify(path));
};

export const peekPostAuthRedirect = (): null | string => {
  const raw = localStorage.getItem(POST_AUTH_REDIRECT_KEY);

  if (!raw) {
    return null;
  }

  try {
    const value = JSON.parse(raw) as string;
    return isSafeInternalRedirect(value) ? value : null;
  } catch {
    return null;
  }
};

export const consumePostAuthRedirect = (): null | string => {
  const value = peekPostAuthRedirect();
  localStorage.removeItem(POST_AUTH_REDIRECT_KEY);
  return value;
};

export const clearPostAuthRedirect = (): void => {
  localStorage.removeItem(POST_AUTH_REDIRECT_KEY);
};

export const navigateToInternalRedirect = (
  navigate: (to: string, options?: { replace?: boolean }) => void,
  path: string,
): void => {
  if (!isSafeInternalRedirect(path)) {
    navigate('/', { replace: true });
    return;
  }

  const queryIndex = path.indexOf('?');
  if (queryIndex === -1) {
    navigate(path, { replace: true });
    return;
  }

  const pathname = path.slice(0, queryIndex);
  const search = path.slice(queryIndex);
  navigate(`${pathname}${search}`, { replace: true });
};
